import React, { Component } from 'react'
import connect from '../utils/connect'
import { doShare } from '../actions'

class ShareDialog extends Component {
  render() {
    return !this.props.isShareDialogShow
      ? <div />
      : <div className='share-dialog-container'>
      <div className='share-dialog-popup'>
        <div className='share-dialog-msg'>
          Мы успешно авторизовались! <br />
          <small>Нажмите кнопку и опубликуйте запись.</small>
        </div>
        <button
          className='share-dialog-btn'
          onClick={ this.props.doShare } >
          Продолжить
        </button>
      </div>
    </div>
  }
}

const mapStateToProps = ({ auth: { isShareDialogShow } }) => ({ isShareDialogShow })
const mapDispatchToProps = ({ doShare })

export default connect(mapStateToProps, mapDispatchToProps)(ShareDialog)



// WEBPACK FOOTER //
// app/javascript/src/components/shareDialog.jsx